import { recommendationActions } from 'actions/recommendationActions';
import get from 'lodash/get';
import { LOADING, SUCCESS, ERROR } from 'utils/asyncStatusHelper';
function getAndSetRecoValuesByWidgetType(state, widgetType, newValue) {
    const widgetValue = get(state, widgetType) || {};
    const updatedState = Object.assign(Object.assign({}, state), { [widgetType]: newValue ? Object.assign({}, widgetValue, newValue) : null });
    if (!newValue) {
        delete updatedState[widgetType];
    }
    return updatedState;
}
export default function recommendationReducer(state = {}, action) {
    switch (action.type) {
        case recommendationActions.RECO_REQUEST:
            return getAndSetRecoValuesByWidgetType(state, action.widgetType, {
                asyncStatus: LOADING
            });
        case recommendationActions.RECO_SUCCESS:
            // To get the data based on the contentIds mapping passed in request and to construct array of ProductSummaryValue
            const recoProducts = (action.contentIds || [])
                .filter(id => action.data[id])
                .map(id => action.data[id].component);
            const currentProducts = get(state, [action.widgetType, 'data']) || [];
            return getAndSetRecoValuesByWidgetType(state, action.widgetType, {
                asyncStatus: SUCCESS,
                data: currentProducts.concat(recoProducts),
                start: action.start || 0
            });
        case recommendationActions.RECO_ERROR:
            return getAndSetRecoValuesByWidgetType(state, action.widgetType, {
                asyncStatus: ERROR,
                error: action.error
            });
        case recommendationActions.RECO_RESET:
            return getAndSetRecoValuesByWidgetType(state, action.widgetType, null);
        default:
            return state;
    }
}
